<template>
  <footer class="pc-footer">
    <div class="footer-wrapper">
      <hr class="mb-2 mt-2" />
      <div class="container-fluid">
        <div class="row">
          <div class="col my-1">
            <p class="m-0">{{ $t('common.footer.copyright', { year: currentYear }) }}</p>
          </div>
          <div class="col-auto my-1">
            <ul class="list-inline footer-link mb-0">
              <li class="list-inline-item"><a href="https://vesproc.com/" target="_blank" rel="noopener noreferrer">{{ $t('common.navigation.home') }}</a></li>
              <li class="list-inline-item"><a href="mailto:support@vesproc.com">{{ $t('common.footer.support') }}</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue';

const currentYear = computed(() => new Date().getFullYear());
</script>

<style scoped>
.pc-footer {
  background: transparent;
 
  padding: 1.5rem 0;
  margin-top: 5rem; /* Çizgi ile sayfa içeriği arasında daha fazla boşluk */
  margin-left: 16rem; /* pc-sidebar genişliği kadar soldan boşluk */
  position: relative;
  z-index: 1;
}

.footer-wrapper {
  padding: 0 1.5rem;
}

.footer-wrapper p {
  color: #666;
  font-size: 0.875rem;
}

.footer-wrapper a {
  color: #212529;
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-wrapper a:hover {
  color: var(--bs-primary);
}

.footer-link {
  margin: 0;
  padding: 0;
  list-style: none;
}

.footer-link li {
  display: inline-block;
  border-right: 1px solid rgba(0, 0, 0, 0.2);
  padding-right: 0.75rem;
  margin-right: 0.75rem;
}

.footer-link li:last-child {
  border-right: none;
  padding-right: 0;
  margin-right: 0;
}

.footer-link a {
  padding: 0;
  font-size: 0.875rem;
  color: #666;
}

.footer-link a:hover {
  color: var(--bs-primary);
}
</style>

